import { FormattedData } from "@components/library/FormattedText";

/** Raw JSON object viewer. */
export const DebugJsonViewer = ({ value }: { value: any }) => {
  return (
    <div className="h-full w-full overflow-visible text-11-14">
      <FormattedData
        value={value}
        containerClassName="py-10 px-8 min-h-[100px]"
        languageSelectLocation="top-right"
        supportedLanguages={["json", "yaml", "json-collapsible"]}
        initialLanguage={"json"}
      />
    </div>
  );
};
